import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UpdateAddressRequestInterface } from 'src/interfaces/address'
import { UserInterface } from 'src/interfaces/user'

export type AuthInfo = UserInterface

type State = {
  loading: boolean
  authInfo: AuthInfo | null
  cardAddress: UpdateAddressRequestInterface | null
  tokenLinkImportPending: boolean
}

const initialState: State = {
  loading: false,
  authInfo: null,
  cardAddress: null,
  tokenLinkImportPending: false,
}

const { actions, reducer } = createSlice({
  // TODO: remember change the name of store
  name: 'app',
  initialState,
  reducers: {
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    updateAuthInfo: (state, action: PayloadAction<AuthInfo | null>) => {
      state.authInfo = action.payload
    },
    patchAuthInfo: (state, action: PayloadAction<Partial<AuthInfo>>) => {
      if (state.authInfo) {
        state.authInfo = { ...state.authInfo, ...action.payload }
      }
    },
    updateCardAddress: (
      state,
      action: PayloadAction<UpdateAddressRequestInterface | null>,
    ) => {
      state.cardAddress = action.payload
    },
    setTokenLinkImportPending: (state, action: PayloadAction<boolean>) => {
      state.tokenLinkImportPending = action.payload
    },
  },
})

export { reducer }
export default actions
